import React, { useState } from 'react';
import ProgressBar from 'components/src/progressBar';
import { Paragraph } from 'components/src/typography';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';
import { Autoplay } from 'swiper/modules';
import { HeroBannerCarouselFieldsFragment, BannerFieldsFragment } from '../../../@types/generated';
import Banner from '.';
import 'swiper/css';
import clsx from 'clsx';
import { HeadingType } from '@/types';
import { centeredMainChildGridClasses } from '@/styles/grid';

type Props = {
  data: HeroBannerCarouselFieldsFragment;
};

const HeroBannerCarousel = ({ data }: Props) => {
  const cardDisplayTime = 7000;
  const [activeIndex, setActiveIndex] = useState(-1);
  const [swiper, setSwiper] = useState<SwiperType>();
  const [autoplayStopped, setAutoplayStopped] = useState(false);
  const numberOfCards = data.bannerCollection?.items.length || 0;

  React.useEffect(() => {
    setActiveIndex(0);
  }, []);

  return (
    <div className={centeredMainChildGridClasses}>
      <div className="col-span-full">
        <Swiper
          onSwiper={setSwiper}
          modules={[Autoplay]}
          autoplay={autoplayStopped ? false : { delay: cardDisplayTime }}
          onActiveIndexChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          onAutoplayStart={() => setAutoplayStopped(false)}
          onAutoplayStop={() => setAutoplayStopped(true)}
        >
          {data.bannerCollection?.items.map((banner, index) => {
            return (
              <SwiperSlide key={index}>
                <Banner data={banner as BannerFieldsFragment} priority={index === 0} />
              </SwiperSlide>
            );
          })}
        </Swiper>
        {numberOfCards >= 2 && (
          <div className="flex justify-center gap-x-24 px-32 pb-24 pt-24 md:pt-40 ">
            {data.bannerCollection?.items.map((banner, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    swiper?.slideTo(index);
                  }}
                  className="w-full max-w-[56px] cursor-pointer select-none md:max-w-[336px]"
                >
                  <ProgressBar
                    progress={index === activeIndex ? 100 : 0}
                    classes={clsx('duration-[7000ms] ease-linear', {
                      '!transition-none': index !== activeIndex || autoplayStopped,
                    })}
                  />
                  <Paragraph
                    classes={`mt-16 hidden text-black-100 transition-all md:flex ${clsx({
                      'font-semibold': index === activeIndex,
                    })}`}
                  >
                    {getHeadingTitle(banner?.heading?.text?.json)}
                  </Paragraph>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export const getHeadingTitle = (heading?: HeadingType): string => {
  if (!heading) {
    return '';
  }

  const title: string[] = [];

  heading.content.forEach((c) =>
    c.content.forEach((item) => {
      title.push(item.value);
    })
  );

  return title.join('');
};

export default HeroBannerCarousel;
